export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const setTagCourse = (state, tags) => {
  state.tagCourses = tags;
};
export const addTagCourse = (state, tags) => {
  state.tagCourses.push(tags);
};
export const removeTagCourses = (state, index) => {
  state.tagCourses.splice(index, 1);
};
export const updateValue = (state, value) => {
  state.tagCourses = value;
};
export const setTags = (state, tags) => {
  tags.forEach(t => {
    t.isEdit = false;
  });
  state.tags = tags;
};
export const addTags = (state, tags) => {
  tags.forEach(t => {
    t.isEdit = false;
  });
  state.tags.push(tags);
};
export const addToTags = (state, tag) => {
  state.tags.push(tag);
};
export const removeByIndex = (state, index) => {
  state.tags.splice(index, 1);
};
export const clearTagCourses = state => {
  state.tagCourses = [];
};
export const clearForm = state => {
  state.formTag.forEach(t => {
    t.model = "";
  });
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/tag/mutations.js